/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style3 = require('antd/lib/breadcrumb/style');

var _breadcrumb = require('antd/lib/breadcrumb');

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style4 = require('antd/lib/layout/style');

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reactRouter = require('react-router');

var _tool = require('../../utils/tool');

var _config = require('../../utils/config');

var _template = require('../../common/template');

var _template2 = _interopRequireDefault(_template);

var _comps = require('comps');

var _device_n = require('./device_n.png');

var _device_n2 = _interopRequireDefault(_device_n);

var _device_s = require('./device_s.png');

var _device_s2 = _interopRequireDefault(_device_s);

var _product_n = require('./product_n.png');

var _product_n2 = _interopRequireDefault(_product_n);

var _product_s = require('./product_s.png');

var _product_s2 = _interopRequireDefault(_product_s);

var _remote_n = require('./remote_n.png');

var _remote_n2 = _interopRequireDefault(_remote_n);

var _remote_s = require('./remote_s.png');

var _remote_s2 = _interopRequireDefault(_remote_s);

var _version_n = require('./version_n.png');

var _version_n2 = _interopRequireDefault(_version_n);

var _version_s = require('./version_s.png');

var _version_s2 = _interopRequireDefault(_version_s);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = _layout2.default.Header,
    Footer = _layout2.default.Footer,
    Sider = _layout2.default.Sider,
    Content = _layout2.default.Content;

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.state = {
      productTemplate: null
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }
  }, {
    key: 'getProductTemplate',
    value: function getProductTemplate() {
      var _this2 = this;

      var params = this.props.params;

      (0, _tool.http)(_config.apiJson.getProductDetail, { productId: params.id }).then(function (res) {
        _this2.setState({
          productTemplate: res.productTemplate
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getProductTemplate();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {}
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          params = _props.params,
          children = _props.children,
          product = _props.product;
      var productTemplate = this.state.productTemplate;

      var role = window.localStorage.getItem("userName");
      var cloneRoutes = _immutable2.default.fromJS(routes);
      cloneRoutes = cloneRoutes.toJS();
      if (!cloneRoutes[cloneRoutes.length - 1].breadcrumbName) {
        cloneRoutes.pop();
      }

      var itemRender = function itemRender(route, params, routes, paths) {
        var last = routes.indexOf(route) === routes.length - 1;

        if (last) {
          return (0, _jsx3.default)('span', {}, void 0, route.breadcrumbName);
        } else {
          if (paths[0] === 'device' || paths[0] === 'version' || paths[0] === 'batterymanagement') {
            return (0, _jsx3.default)(_reactRouter.Link, {
              to: '/' + paths.join('/') + '/index/' + params.id
            }, void 0, route.breadcrumbName);
          } else {
            return (0, _jsx3.default)(_reactRouter.Link, {
              to: '/' + paths.join('/')
            }, void 0, route.breadcrumbName);
          }
        }
      };

      var pathObj = [{
        name: productTemplate === 2 ? '产品概况' : '车型概况',
        img: {
          s: _product_s2.default,
          n: _product_n2.default
        },
        matchpath: 'product',
        link: '/product/' + params.id
      }, {
        name: productTemplate === 2 ? '设备管理' : '车辆管理',
        img: {
          s: _device_s2.default,
          n: _device_n2.default
        },
        matchpath: 'device',
        link: '/device/index/' + params.id
      }, {
        name: '版本信息',
        img: {
          s: _remote_s2.default,
          n: _remote_n2.default
        },
        matchpath: 'remote',
        link: '/remote/' + params.id
      }, {
        name: '升级包管理',
        img: {
          s: _version_s2.default,
          n: _version_n2.default
        },
        matchpath: 'version',
        link: '/version/index/' + params.id
      }, {
        name: '渠道管理',
        img: {
          s: _version_s2.default,
          n: _version_n2.default
        },
        matchpath: 'channel',
        link: '/channel/index/' + params.id
      }, {
        name: '电池管理',
        img: {
          s: _device_s2.default,
          n: _device_n2.default
        },
        matchpath: 'batterymanagement',
        link: '/batterymanagement/index/' + params.id
      }];
      if (role == ' 嘉为-黄海燕') {
        pathObj.pop();
      }
      if (role == 'factory1') {
        pathObj.forEach(function (item, index) {
          if (item.name == '版本信息') {
            pathObj.splice(index, 1);
          }
        });
        pathObj.forEach(function (item, index) {
          if (item.name == '升级包管理') {
            pathObj.splice(index, 1);
          }
        });
      }
      if (role == '立马专属账号') {
        pathObj = pathObj.filter(function (item) {
          return item.name != '升级包管理' && item.name != '渠道管理' && item.name != '电池管理';
        });
      }

      return (0, _jsx3.default)('div', {
        className: 'layout'
      }, void 0, (0, _jsx3.default)(_layout2.default, {
        className: 'cus-layout'
      }, void 0, (0, _jsx3.default)(Sider, {
        className: 'cus-sider',
        style: { width: 100 }
      }, void 0, (0, _jsx3.default)(_comps.Menu, {
        pathObj: pathObj
      })), (0, _jsx3.default)(Content, {
        className: 'cus-content'
      }, void 0, (0, _jsx3.default)(Header, {
        className: 'cus-content-header'
      }, void 0, (0, _jsx3.default)(_breadcrumb2.default, {
        routes: cloneRoutes,
        params: params,
        separator: '>',
        itemRender: itemRender
      })), (0, _jsx3.default)(Content, {
        className: 'cus-content-pages'
      }, void 0, children))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _template2.default)({
  id: 'layout', // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/layout/index.jsx
// module id = 655
// module chunks = 0